<template>
  <div class="static-tables">
    <div class="row">
      <div class="col col-12 text-right">
        <file-download-link
          extraClasses="mb-3"
          :src="spreadsheetDownloadURL"
        />
      </div>
    </div>
    <div class="row">
      <div 
        v-for="table in tables"
        :key="table.name"
        class="d-flex col col-12 col-sm-6 col-md-4 col-lg-3 mb-1 align-items-stretch"
      >
        <router-link
          :to="table"
          class="btn btn-primary d-flex w-100 justify-content-center align-items-center"
        >{{ table.name }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import FileDownloadLink from '../../components/FileDownloadLink.vue'
  import routes from '../../components/StaticTable/data/static-table-routes.json'
  export default {
    name: 'static-tables',
    components: {
      FileDownloadLink
    },
    data: function() {
      const tables = []
      for(let i = 1; i < routes.length; i++) {
        const route = routes[i]
        tables.push({
          name: route.name,
          props: route.props
        })
      }
      tables.sort((a, b) => a.name.localeCompare(b.name))
      return {
        spreadsheetDownloadURL: '/api/static-tables/excel',
        tables
      }
    }
  };
</script>
<style lang="scss">
  .static-tables {
    .file-download-link {
      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }
</style>